<template>
    <img
        :src="
            !props.groupSameCards
                ? item[0]?.institution?.small_logo_url
                : item[0]?.cards[0]?.institution?.small_logo_url
        "
        class="sm:w-5 w-7 h-auto rounded-full"
        alt="Bank logo"
    />
    {{ $filters.titleCase(name) }}
</template>
<script setup>
const props = defineProps({
    item: { type: Object, required: true }, //either a card object or an object rep. a group of same cards
    groupSameCards: { type: Boolean, required: true },
    name: { type: String, required: true },
});
</script>
